import React from 'react';

import formatDate from '@ps-int/ufo-helpers/lib/date/date-to-string';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../shared/helpers/i18n';
import { BroadcastInfoData, getBroadcastInfo } from '../../features/broadcast/selectors';
import classes from './index.css';

type GetInfoTextInterface = {
    viewers: (count: number) => string;
    createdByDisplayName: (name: string) => string;
    startedAt: (timestamp: number) => string;
};

const getInfoText: {
    [key in keyof Required<BroadcastInfoData>]: GetInfoTextInterface[key];
} = {
    viewers: (count: number) => i18n('broadcast-view', 'viewers-count', { count }),
    createdByDisplayName: (name: string) => i18n('broadcast-view', 'created-by', { name }),
    startedAt: (timestamp: number) =>
        i18n('broadcast-view', 'started-at', {
            time: formatDate(new Date(timestamp * 1000), 'HH:mm'),
        }),
} as const;

export const BroadcastInfo = () => {
    const info = useSelector(getBroadcastInfo);

    if (!info) {
        return null;
    }

    const keys = Object.keys(info) as (keyof GetInfoTextInterface)[];
    const content = keys
        .map((key) => {
            const value = info[key];
            const textInfoGetter = getInfoText[key] as (param: typeof value) => string;

            return <span key={key}>{textInfoGetter(value)}</span>;
        })
        .reduce((accumulator, current, index, array) => {
            accumulator.push(current);
            if (index !== array.length - 1) {
                accumulator.push(<span key={index} className={classes.BroadcastInfo__Separator} />);
            }
            return accumulator;
        }, [] as JSX.Element[]);

    return <div className={classes.BroadcastInfo}>{content}</div>;
};
